import { render, staticRenderFns } from "./CreateClassroom.vue?vue&type=template&id=40e25736"
import script from "./CreateClassroom.vue?vue&type=script&lang=js"
export * from "./CreateClassroom.vue?vue&type=script&lang=js"
import style0 from "./CreateClassroom.vue?vue&type=style&index=0&id=40e25736&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports